import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { HeaderService } from 'src/app/core/services/header/header.service';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./public-layout.component.css'],
  styles: [
    `
      router-outlet {
        display: contents;
      }
    `,
  ],
  standalone: false,
})
export class PublicLayoutComponent implements OnInit {
  copyrightYear: number = new Date().getFullYear();

  private headerService = inject(HeaderService);

  ngOnInit(): void {
    this.headerService.hideNav();
  }
}
